import type { AssessmentResultsByParentIdResponse } from '@risksmart-app/trpc/src/types';
import type { GetAssessmentResultsByParentIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAssessmentResultsByParentIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseGetAssessmentResultsByParentIdArgs = {
  ParentId: string;
};

export const useGetAssessmentResultsByParentIdLazy = createLazyQueryHook<
  UseGetAssessmentResultsByParentIdArgs,
  AssessmentResultsByParentIdResponse,
  GetAssessmentResultsByParentIdQuery
>({
  trpcQuery: (client, args) =>
    client.frontend.assessment.resultsByParentId.query({
      parentId: args.ParentId,
    }),
  mapTrpcDataToGraphQL: (data) => ({
    document_assessment_result: data.document_assessment_result,
    obligation_assessment_result: data.obligation_assessment_result,
    risk_assessment_result: data.risk_assessment_result,
    test_result: data.test_result,
    impact_rating: data.impact_rating,
    issue: data.issue,
    impact: data.impact,
    action: data.action,
  }),
  graphqlDocument: GetAssessmentResultsByParentIdDocument,
  graphqlVariables: (args) => ({ ParentId: args.ParentId }),
});
